<template>
   <div id="upload_area">
      <!-- Initial Form -->
      <form v-if="isInitial || isFailed || isSuccess" ref="form" id="upload" enctype="multipart/form-data" novalidate>

         <div id='dropzone_container'>
            <div class="image-container">
            <img class="drag-icon" src="./../../assets/img/drag-graphic.png"> 
            </div>
            <div>Drag Files Here</div>
            <input type="file" 
               multiple 
               name="files[]" 
               :disabled="isUploading || isIngesting || isFetching" 
               @change="$emit('filesChange', $event.target.name, $event.target.files)"
               :accept="accepted" class="input-file">
            <label for="fileupload" class='btn btn-default filestyle'>(Or browse for files to upload)</label>
         </div>

      </form>

      <!-- <div v-if="invalidExtFiles.length > 0" id="invalid_files_container">
         The following files have extensions that are not currently compatible with Bard:
         <span v-for="file of invalidExtFiles">{{file.name}}</span>
      </div> -->
   </div>
</template>

<script>
// import vueDropzone from "vue2-dropzone";
import { mapActions, mapState, mapGetters  } from 'vuex';

export default {
   // data() {
   //    return {
   //       uploadFieldName: '',
   //       uploadError: null,
   //       uploadedFiles: [],
   //       successFiles: [],
   //       uploadTotal: 0,
   //       uploadProgress: 0,
   //       fileCount: 0
   //    }
   // },

   props: {
      // currentStatus: Number,
      accepted: String
   },

   computed: {
      ...mapState('global', ['invalidExtFiles']),

      ...mapGetters('global', [
         'isInitial',
         'isUploading',
         'isIngesting',
         'isFetching', 
         'isSuccess', 
         'isFailed',   
      ]),
   }

}
</script>

<style lang="scss" scoped>

#dropzone_container {
   background-color: transparent;
   border: none;
   text-align: center;
   position: relative;
   color: white;

   input {
      position: absolute;
      width: 100%;
      height: 303px;
      left: 0;
      top: -64px;
      opacity: 0;
   }
}

.drag-icon {
   width: 175px;
   height: 150px;
   position: relative;
   pointer-events: none;
}

.files-container {
   padding-bottom: 10px;
}

.uploaded-message {
   padding: 10px 0;
}

.file-row {
   display: flex;
   border: 1px solid $bard-gray;

   &:not(:last-child) {
      border-bottom: none;
   }

   .file-row-load-indicator {
      height: 50px;
      background: rgba(128, 128, 128, .2);
      position: absolute;
      z-index: 0;
   }

   .file-thumb {
      width: 50px;
      height: 50px;
   }

   .file-text-container {
      text-align: left;
      padding-left: 5px;
      padding-top: 6px;
   }

   .filename {
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
   }

   .file-size {
      font-size: 10px;
      color: $bard-gray;
   }
}

.filestyle {
   text-decoration: underline;
   color: $bard-gray;
}
</style>